/** Immediate single taps with an atomic second-tap promotion; no delayed mark. */
export class TileInput {
  constructor({
    perform,
    state,
    revision,
    now = () => performance.now(),
    doubleTapMs = 330,
  }) {
    this.perform = perform;
    this.state = state;
    this.revision = revision;
    this.now = now;
    this.doubleTapMs = doubleTapMs;
    this.last = null;
  }
  reset() {
    this.last = null;
  }
  tap(index, { keyboard = false } = {}) {
    const state = this.state();
    if (state.status !== "playing" || state.puzzle.givens.includes(index) || state.failedCells?.includes(index)) {
      this.reset();
      return;
    }
    if (keyboard) {
      this.reset();
      this.perform("mark", index);
      return;
    }
    const now = this.now();
    if (
      this.last?.index === index &&
      now - this.last.time <= this.doubleTapMs &&
      this.last.revision === this.revision()
    ) {
      const kind = this.last.kind;
      this.reset();
      if (kind === "mark") this.perform("promoteMark", index);
      return;
    }
    this.reset();
    const kind = state.cats.includes(index) ? "clear" : "mark";
    const effect = this.perform(kind, index);
    if (effect?.changed)
      this.last = { index, kind, time: now, revision: this.revision() };
  }
}
